export interface SearchTermOption {
    value: any;
    label: string;
}

export class SearchTermOptionsHelper {

    static create(): SearchTermOption {
        return {
            value: '',
            label: ''
        };
    }

    static transformFromApi(apiData: Object): SearchTermOption {
        const searchOption = SearchTermOptionsHelper.create();
        searchOption.value = apiData['BUSQUEDA'];
        searchOption.label = apiData['BUSQUEDA'];
        return searchOption;
    }
}